import { RootState } from 'Data/Redux';
import { hasNonEmptyValue } from 'Lib/Any';
import { noop } from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../Data/ReduxViewModels/WorksheetBatchUpdate';
import * as oPath from '../../../../Lib/Object/Path/Immutable';
import { InjectedPropsProvider, withInjectedProps } from '../../../Core/InjectedPropsContext';

/***************
 * TODO: The provider props here is mostly basic change handling, very similar to other provider props.
 * Should think about how some of this can be made common.
 ****************/
// Only props you want to override on the consumer need to be returned.
const getWorksheetBatchUpdateQueryProviderProps = (consumerProps: any, providerData: any) => {
  const { name, onChange: consumerOnChange, value: consumerValue, copyTo } = consumerProps;
  const { setValue, submit, data, locked } = providerData;

  let providerProps: any = { hasInjectedProps: true };

  // Set value
  if (name && consumerValue === undefined) {
    let value = oPath.get(data, name);
    if (value === undefined) value = null; // Remove undefined
    providerProps.value = value;
  }

  // Set onChange
  if (name && !consumerOnChange) {
    const onChange = (e: any) => {
      const {
        data: { value, submitValues = false },
      } = e;
      if (name !== undefined && value !== undefined) {
        setValue({ name, value, sync: submitValues });
        copyTo?.forEach((d: any) => setValue({ name: d, value, sync: submitValues }));
      } else if (submitValues) submit();
    };

    providerProps.onChange = onChange;
  }

  // Disabled query fields when a uri param is provided by a wrapping frame (i.e. QESTLab)
  providerProps.selectors = {
    disabled: (state: RootState) => ({
      disabled:
        consumerProps.disabled ||
        locked ||
        (hasNonEmptyValue(state.worksheetBatchUpdate.query.uriParams[name]) && window.qest.isFrame),
    }),
  };

  return providerProps;
};

let WorksheetBatchUpdateQueryInjectedPropsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch();
  const data = useSelector((s) => s.worksheetBatchUpdate.query?.enteredParams);
  const isQueryReady = useSelector((s) => s.worksheetBatchUpdate.status.queryReady);

  const locked = useSelector(
    (state) =>
      !state.worksheetBatchUpdate.status.initialised ||
      state.worksheetBatchUpdate.status.applyingUpdate ||
      state.worksheetBatchUpdate.status.checking
  );

  const setValue = (opts: any) => dispatch(actions.setQueryValue(opts));
  const submit = isQueryReady ? () => dispatch(actions.refreshWorksheets()) : noop;
  const providerData = {
    data,
    setValue,
    submit,
    locked,
  };
  return (
    <InjectedPropsProvider
      getProviderProps={(consumerProps: any, _: any) =>
        getWorksheetBatchUpdateQueryProviderProps(consumerProps, providerData)
      }
    >
      {children}
    </InjectedPropsProvider>
  );
};

WorksheetBatchUpdateQueryInjectedPropsProvider = withInjectedProps(WorksheetBatchUpdateQueryInjectedPropsProvider);

export { WorksheetBatchUpdateQueryInjectedPropsProvider };
export default WorksheetBatchUpdateQueryInjectedPropsProvider;
